import { CurrentRfqStatusThemeModeConfig } from './types';

const dark: CurrentRfqStatusThemeModeConfig = {
  currentRfqStatus: {},
};

export default dark;
